import { createApp, h } from "vue";
import App from "./App.vue";
import router from "./router";
import { axiosInit } from "@/tools/axios-init.js";
import { createPinia, defineStore } from "pinia";
import environment from "@/environment";
import "@/assets/styles/main.scss";
import {VOnClickOutside} from "@/directives/clickOutside";
import axios from "axios";
import VueApexCharts from "vue3-apexcharts";

// Globus UI KIT
import GlobusUI from "@globus/ui-kit";
import "@globus/ui-kit/dist/globus-ui-kit.css";
import "@globus/ui-kit/themes/lk.css";
import  "@globus/ui-kit/themes/globus.css";

export const useLK = defineStore({
    ...window.LKStore
});

const app = createApp({
    mounted() {
        console.log("[START] Start Sources Application v ", process.env.VUE_APP_VERSION);
        localStorage.setItem("appVersion", process.env.VUE_APP_VERSION);
        const LKStore = useLK();
        window.LKAxios(axios, LKStore);
        window.initRouterLK(LKStore);
        window.moduleInit(environment.settings, router, LKStore);
    },
    render: () => h(App)
});

const pinia = createPinia();

app.directive("clickOutside", VOnClickOutside);
app.use(pinia);
app.use(router);
app.use(GlobusUI);
app.use(VueApexCharts);


axiosInit();

app.mount("#app");